import { render, staticRenderFns } from "./ClearDBCache.vue?vue&type=template&id=134f44e5&scoped=true"
import script from "./ClearDBCache.vue?vue&type=script&lang=js"
export * from "./ClearDBCache.vue?vue&type=script&lang=js"
import style0 from "./ClearDBCache.vue?vue&type=style&index=0&id=134f44e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134f44e5",
  null
  
)

export default component.exports